/* ============================================
   THE VITAMIN PATCH — shopify-products.js
   Product Data via Storefront API
   ============================================
   REQUIRES: shopify-config.js + shopify-cart.js

   WHAT THIS DOES:
   - Renders live products into catalog.html
   - Loads live prices on product detail pages
   - Powers "Add to Cart" on product pages
   - Populates "You Might Also Love" section
   ============================================ */

(function() {
  'use strict';

  /* ------------------------------------------
     QUERIES
     ------------------------------------------ */
  var GET_PRODUCTS = '\
    query getProducts($first: Int!) {\
      products(first: $first, sortKey: TITLE) {\
        edges { node {\
          id handle title\
          priceRange { minVariantPrice { amount } }\
          compareAtPriceRange { minVariantPrice { amount } }\
          featuredImage { url altText }\
          variants(first: 10) { edges { node {\
            id title availableForSale\
            price { amount }\
            compareAtPrice { amount }\
          }}}\
        }}\
      }\
    }';

  var GET_PRODUCT = '\
    query getProduct($handle: String!) {\
      productByHandle(handle: $handle) {\
        id handle title\
        variants(first: 20) { edges { node {\
          id title availableForSale\
          price { amount }\
          compareAtPrice { amount }\
        }}}\
        images(first: 8) { edges { node { url altText } } }\
        sellingPlanGroups(first: 5) { edges { node {\
          sellingPlans(first: 5) { edges { node { id name } } }\
        }}}\
      }\
    }';

  /* ------------------------------------------
     BUILD PRODUCT CARD
     Matches your existing .ps-card structure
     ------------------------------------------ */
  function buildCard(product) {
    var v        = product.variants.edges[0] ? product.variants.edges[0].node : null;
    var price    = product.priceRange.minVariantPrice.amount;
    var compare  = product.compareAtPriceRange.minVariantPrice.amount;
    var img      = product.featuredImage ? product.featuredImage.url : '';
    var alt      = product.featuredImage ? product.featuredImage.altText || product.title : product.title;
    var inStock  = v ? v.availableForSale : false;
    var varId    = v ? v.id : '';
    var onSale   = compare && parseFloat(compare) > parseFloat(price);
    if (window.TVP_SALE && TVP_SALE.on(product.handle)) { compare = price; price = TVP_SALE.price(price); onSale = true; }

    var badge = '';
    if (!inStock) badge = '<span class="ps-badge" style="background:#888;">SOLD OUT</span>';
    else if (onSale) badge = '<span class="ps-badge" style="background:#f97316;">SALE</span>';

    var priceHTML = TVP.formatPrice(price);
    if (onSale) priceHTML = '<span style="text-decoration:line-through;color:#aaa;margin-right:6px;">' + TVP.formatPrice(compare) + '</span>' + TVP.formatPrice(price);

    return '<div class="ps-card" data-handle="' + product.handle + '">' +
      '<a href="product-' + product.handle + '.html" class="ps-card-img-wrap">' +
        badge +
        '<img src="' + img + '" alt="' + alt + '" class="ps-card-img" loading="lazy" />' +
      '</a>' +
      '<div class="ps-card-body">' +
        '<div class="ps-card-name">' + product.title + '</div>' +
        '<div class="ps-card-price">' + priceHTML + '</div>' +
        '<button class="ps-card-atc pill-btn pill-btn-sm" data-variant-id="' + varId + '"' +
          (!inStock ? ' disabled style="opacity:.5;cursor:not-allowed;"' : '') + '>' +
          (inStock ? 'ADD TO CART' : 'SOLD OUT') +
        '</button>' +
      '</div>' +
    '</div>';
  }

  /* ------------------------------------------
     BIND ADD TO CART BUTTONS
     ------------------------------------------ */
  function bindATC(container) {
    container.querySelectorAll('.ps-card-atc').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var vid = btn.getAttribute('data-variant-id');
        if (!vid || btn.disabled) return;
        btn.textContent = 'ADDING...';
        btn.disabled = true;
        TVP.cart.add(vid, 1).then(function() {
          btn.textContent = 'ADDED ✓';
          setTimeout(function() { btn.textContent = 'ADD TO CART'; btn.disabled = false; }, 2000);
        }).catch(function() { btn.textContent = 'ADD TO CART'; btn.disabled = false; });
      });
    });
  }

  /* ------------------------------------------
     CATALOG PAGE
     Add id="tvpProductGrid" to your grid container
     ------------------------------------------ */
  function initCatalog() {
    var grid = document.getElementById('tvpProductGrid');
    if (!grid) return;

    grid.innerHTML = '<div style="text-align:center;padding:60px;font-family:Barlow,sans-serif;color:#888;">Loading patches...</div>';

    TVP.api(GET_PRODUCTS, { first: 24 }).then(function(data) {
      var products = data.products.edges;
      if (!products.length) {
        grid.innerHTML = '<p style="text-align:center;font-family:Barlow,sans-serif;color:#888;">No products found.</p>';
        return;
      }
      var html = '';
      products.forEach(function(e) { html += buildCard(e.node); });
      grid.innerHTML = html;
      bindATC(grid);
    }).catch(function(err) {
      console.error('[TVP] Catalog error:', err);
      grid.innerHTML = '<p style="text-align:center;color:#c00;font-family:Barlow,sans-serif;">Could not load products. Please try again.</p>';
    });
  }

  /* ------------------------------------------
     PRODUCT DETAIL PAGE
     Add data-product-handle="your-handle" to <body>
     and id="tvpAddToCart" to your Add to Cart button
     ------------------------------------------ */
  function initProductPage() {
    var priceDisplay = document.getElementById('priceDisplay');
    if (!priceDisplay) return;

    var handle = document.body.getAttribute('data-product-handle');
    if (!handle) {
      var filename = window.location.pathname.split('/').pop().replace('.html', '');
      handle = filename.replace(/^product-/, '');
    }

    TVP.api(GET_PRODUCT, { handle: handle }).then(function(data) {
      var product = data.productByHandle;
      if (!product) { console.warn('[TVP] Product not found:', handle); return; }

      var first = product.variants.edges[0] ? product.variants.edges[0].node : null;
      if (!first) return;

      /* Update price display */
      priceDisplay.textContent = TVP.formatPrice(first.price.amount);
      var strikeEl = document.getElementById('priceStrike');
      if (strikeEl && first.compareAtPrice) {
        strikeEl.textContent = TVP.formatPrice(first.compareAtPrice.amount);
        strikeEl.style.display = 'inline';
      }
      if (window.TVP_SALE && TVP_SALE.on(handle)) {
        priceDisplay.textContent = TVP.formatPrice(TVP_SALE.price(first.price.amount));
        if (strikeEl) { strikeEl.textContent = TVP.formatPrice(first.price.amount); strikeEl.style.display = 'inline'; }
      }

      /* Store variants globally for variant selectors */
      window._tvpVariants = product.variants.edges.map(function(e) { return e.node; });

      /* Wire Add to Cart button */
      var atcBtn = document.getElementById('tvpAddToCart');
      if (!atcBtn) return;
      atcBtn.setAttribute('data-variant-id', first.id);

      var sellingPlanId = '';
      if (product.sellingPlanGroups && product.sellingPlanGroups.edges.length) {
        var firstGroup = product.sellingPlanGroups.edges[0].node;
        if (firstGroup.sellingPlans.edges.length) {
          sellingPlanId = firstGroup.sellingPlans.edges[0].node.id;
        }
      }
      atcBtn.setAttribute('data-selling-plan-id', sellingPlanId);

      atcBtn.addEventListener('click', function() {
        var vid   = atcBtn.getAttribute('data-variant-id');
        var qtyEl = document.getElementById('qtyVal');
        var qty   = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;

        var activeOpt = document.querySelector('.sub-opt.active');
        var isSub = activeOpt && activeOpt.getAttribute('data-type') === 'sub';
        var planId = isSub ? atcBtn.getAttribute('data-selling-plan-id') : null;

        atcBtn.textContent = 'ADDING...';
        atcBtn.disabled = true;

        TVP.cart.add(vid, qty, planId).then(function() {
          atcBtn.textContent = 'ADDED ✓';
          setTimeout(function() { atcBtn.textContent = 'ADD TO CART'; atcBtn.disabled = false; }, 2000);
        }).catch(function() { atcBtn.textContent = 'ADD TO CART'; atcBtn.disabled = false; });
      });

    }).catch(function(err) { console.error('[TVP] Product page error:', err); });
  }

  /* ------------------------------------------
     RELATED PRODUCTS
     Renders into .related-grid on product pages
     ------------------------------------------ */
  function initRelated() {
    var grid = document.querySelector('.related-grid');
    if (!grid) return;

    var currentHandle = document.body.getAttribute('data-product-handle') || '';

    TVP.api(GET_PRODUCTS, { first: 8 }).then(function(data) {
      var related = data.products.edges
        .filter(function(e) { return e.node.handle !== currentHandle; })
        .slice(0, 4);

      if (!related.length) return;

      var html = '';
      related.forEach(function(edge) {
        var p   = edge.node;
        var img = p.featuredImage ? p.featuredImage.url : '';
        html += '<a href="product-' + p.handle + '.html" class="rel-card">' +
          '<div class="rel-img"><img src="' + img + '" alt="' + p.title + '" style="width:100%;height:100%;object-fit:cover;"/></div>' +
          '<div class="rel-body">' +
            '<div class="rel-name">' + p.title + '</div>' +
            '<div class="rel-desc">' + (window.TVP_SALE && TVP_SALE.on(p.handle) ? '<span style="text-decoration:line-through;color:#aaa;margin-right:6px;">' + TVP.formatPrice(p.priceRange.minVariantPrice.amount) + '</span>' + TVP.formatPrice(TVP_SALE.price(p.priceRange.minVariantPrice.amount)) : TVP.formatPrice(p.priceRange.minVariantPrice.amount)) + '</div>' +
          '</div>' +
        '</a>';
      });
      grid.innerHTML = html;
    }).catch(function(err) { console.error('[TVP] Related products error:', err); });
  }

  /* ------------------------------------------
     INIT
     ------------------------------------------ */
  function init() {
    initCatalog();
    initProductPage();
    // initRelated(); // disabled - overwrote correct hardcoded related products with wrong wholesale items
  }

  window.TVP = window.TVP || {};
  window.TVP.products = {
    fetchAll: function(n) { return TVP.api(GET_PRODUCTS, { first: n || 24 }); },
    fetchOne: function(h) { return TVP.api(GET_PRODUCT, { handle: h }); }
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();
